module.exports = __webpack_public_path__ + "img/edx-logo-registered.27095f4c.png";